module.exports = __webpack_public_path__ + "static/media/peeps.06624456.png";